export const emailRegex =/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const phoneRegex = /^[0-9]\d{9}$/;

export const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;

export const nameRegex = /^[a-zA-Z ]*$/;

export const aadharRegex = /(^[0-9]{4}[0-9]{4}[0-9]{4}$)|(^[0-9]{4}\s[0-9]{4}\s[0-9]{4}$)|(^[0-9]{4}-[0-9]{4}-[0-9]{4}$)/;

export const panRegex = /(^([A-Z]{5})([0-9]{4})([A-Z]{1})$)/;

export const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

export const wordToWordSpaceRegex = /^(?! )[a-zA-Z'-]+(?: [a-zA-Z'-]+)*(?<! )$/;
 
export const floatingRegex = /^-?\d*\.?\d*$/;
 
export const numbernamesRegex = /^[a-zA-Z0-9\s'-]*$/;

export const numberRegex = /^[0-9\b]+$/;

export const numbercharRegex = /^[0-9\/]+$/;

export const numberandspecialcharacterRegex = /^[0-9!@#$%^&*()_+={}\[\]:;"'<,>.?/~|\-]*$/

